import { FC } from "react";
import { Box, Image } from "@chakra-ui/react";
import SmArrow from "~/images/bottom-right-arrow-sm.svg";
import Arrow from "~/images/bottom-right-arrow.svg";

export const BottomRightArrow: FC = () => {
  return (
    <>
      <Box
        display={{ base: "none", lg: "initial" }}
        position="absolute"
        left="-9rem"
        top="-7rem"
      >
        <Image alt="Bottom right arrow" src={Arrow} />
      </Box>
      <Box
        display={{ base: "initial", lg: "none" }}
        position="absolute"
        left="-3rem"
        top="0.5rem"
      >
        <Image alt="Bottom right arrow" src={SmArrow} />
      </Box>
    </>
  );
};
